import { CancelTokenSource } from 'axios'
import AnonymousAgent from '../api/AnonymousAgent'

class CalloutService {
  getCallout = async (
    page: string,
    position: string,
    source?: CancelTokenSource
  ) => {
    return await AnonymousAgent.Callout.getCalloutByPage(page, position, source)
  }
}

export default new CalloutService()
